import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/plus-white.svg';
import _imports_1 from '@/img/icon/drawer.svg';
const _withScopeId = n => (_pushScopeId("data-v-13287f57"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-wrapper"
};
const _hoisted_2 = {
  class: "address__head"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "address__title"
}, "Адрес доставки", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "plus"
}, null, -1));
const _hoisted_5 = {
  class: "address__list"
};
const _hoisted_6 = {
  class: "address__info"
};
const _hoisted_7 = {
  class: "address__address"
};
const _hoisted_8 = {
  class: "address__other"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "address__remove-btn"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "address"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_EmptyBlock = _resolveComponent("EmptyBlock");
  const _directive_auto_animate = _resolveDirective("auto-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_app_button, {
    class: "address__btn",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/rol-shop/map'))
  }, {
    default: _withCtx(() => [_createTextVNode(" Новый адрес "), _hoisted_4]),
    _: 1
  })]), _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.address, (item, id) => {
    return _openBlock(), _createElementBlock("li", {
      class: "address__list-item",
      key: id
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(`${item.city}, ${item.address}`), 1), _createElementVNode("p", _hoisted_8, " Подьезд " + _toDisplayString(item.input) + ", этаж " + _toDisplayString(item.floor) + ", квартира " + _toDisplayString(item.apartment), 1)]), _createVNode(_component_el_popconfirm, {
      width: "220",
      title: "Вы уверены что хотите удалить адрес?",
      onConfirm: $event => $options.removeAddress(item.id),
      "confirm-button-text": "да",
      "cancel-button-text": "нет",
      "icon-color": "#626AEF",
      icon: $setup.iconInfo
    }, {
      reference: _withCtx(() => [_hoisted_9]),
      _: 2
    }, 1032, ["onConfirm", "icon"])]);
  }), 128))])), [[_directive_auto_animate]]), $setup.address.length == 0 ? (_openBlock(), _createBlock(_component_EmptyBlock, {
    key: 0,
    imgUrl: require('@/img/icon/address-empty.svg'),
    title: "У вас нет сохраненных адресов",
    text: "Переходите в интересующую вас категорию и сделайте свой первый заказ и адрес сохранится автоматически"
  }, null, 8, ["imgUrl"])) : _createCommentVNode("", true)]);
}